import store from '../store'

export default [
  {
    path: '/industrias/:key/email',
    name: 'industrias-create-email',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.commit('setEmail', {})
      await store.dispatch('getIndustria', {
        id: Number(to.params.key)
      })
      next()
    },
    meta: {
      title: 'Novo email da industria',
      documentAttrTelefone: 'industria',
      titleAttr: 'nome_fantasia',
      actionSaveEmail: 'postSaveEmailNaIndustria',
      titleAlertRemoveEmail: 'Confirme a exclusão deste email da industria.',
      routeToBack: 'industrias-update',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/email')
    }
  },
  {
    path: '/industrias/:key/email/:id',
    name: 'industrias-update-email',
    props: true,
    beforeEnter: async (to, from, next) => {
      await store.dispatch('getEmailDaIndustria', {
        id: Number(to.params.id)
      })
      await store.dispatch('getIndustria', {
        id: Number(to.params.key)
      })
      next()
    },
    meta: {
      title: 'Editar email da industria',
      documentAttrTelefone: 'industria',
      titleAttr: 'nome_fantasia',
      actionSaveEmail: 'postSaveEmailNaIndustria',
      titleAlertRemoveEmail: 'Confirme a exclusão deste email da industria.',
      routeToBack: 'industrias-update',
      requireAuth: true
    },
    component: function () {
      return import(/* webpackChunkName: "routes" */ '@/views/email')
    }
  }
]
